import { Language } from "./language";

export class LeadEmailTemplate {
    constructor(
        public name: string,
        public body: string,
        public language: Language,
        public subject: string,
        public id?: number
    ){}
}
